<mpro-loading *ngIf="dataService.getIsLoading() | async"></mpro-loading>
<div>
  <span class="header">Consumer Demand</span>
  <p class="sub-header">{{ dataFilters.regionSelection.getName() }} - {{ dataFilters.year }}</p>
  <mpro-tags style="margin: 15px 0px;"></mpro-tags>
  <p class="margin">Annual Demand growth</p>
  <div class="dropdown-div">
    <div>
      <button class="openButton" (click)="changeStartYearOpen()">{{ startYear }}<fa-icon [icon]="faCaretDown"></fa-icon></button>
      <div class="dropdown" *ngIf="startYearOpen">
          <button *ngFor="let year of startYears" (click)="setStartYear(year, true)">{{ year }}</button>
      </div>
    </div>
    <p class="to">to</p>
    <div>
      <button class="openButton" (click)="changeEndYearOpen()"> {{ endYear }}<fa-icon [icon]="faCaretDown"></fa-icon></button>
      <div class="dropdown" *ngIf="endYearOpen">
          <button *ngFor="let year of endYears" (click)="setEndYear(year, true)">{{ year }}</button>
      </div>
    </div>
  </div>
  <mpro-info-box [left]="totalAdressableBox" [right]="largerThanAvgBox" [color]="getInfoBoxTextColor()"></mpro-info-box>
</div>
